import * as yup from "yup";

const dayoffDocumentValidation = yup.object().shape({
  dayoffTypeId: yup
    .number()
    .min(1, "Bu alan zorunludur")
    .required("Bu alan zorunludur"),
  documentTypeId: yup
    .number()
    .min(1, "Bu alan zorunludur")
    .required("Bu alan zorunludur"),
});

export default dayoffDocumentValidation;
